module.exports = __webpack_public_path__ + "static/media/co2_icon.50e24af2.svg";